// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"70a5f74c","885":"45170d85","963":"ad0ef5cf"}[chunkId] + ".chunk.js";
};